import React from 'react'
import {injectIntl} from 'react-intl'
import {PhoneInput} from '@framelink/phone_input'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import {getCountry} from 'utils/utils'
import flags from 'images/flags.png'

class PhoneFieldConfig extends React.Component {
    constructor(props) {
        super(props)

        const country = this.props.config.country || getCountry()

        this.state = {
            country: country || 'us'
        }
    }

    handleChange(data) {
        this.setState({ country: data.iso2 })
    }

    changeType = () => {
        this.props.changeTypeToPhone({...this.state})
        this.props.onClose()
        this.props.handleCloseMenu()
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {intl.formatMessage({id: "config.phone_field_title"})}
                </DialogTitle>
                <DialogContent style={{overflowY: 'visible'}}>
                    <PhoneInput
                        classNames='phoneConfig'
                        defaultCountry={this.state.country}
                        onChange={(code, data) => this.handleChange(data)}
                        flagsImagePath={flags}
                        type='select'
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button onClick={this.changeType} color="primary" variant="contained">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(PhoneFieldConfig)
